import React from 'react'
import { withStyles } from '@mui/styles'
import { Typography, Box } from '@mui/material'

import { actionButtonStyles } from './action-button.styles'

/**
 * @typedef {object} ActionButtonProps
 * @property {object} classes - Objeto con los nombres de las clases CSS inyectado por withStyles.
 * @property {string} label - El texto que se muestra como etiqueta del botón.
 * @property {React.ReactNode} icon - El icono que se muestra a la izquierda del label.
 * @property {function(): void} onClick - La función callback que se ejecuta cuando se hace clic en el botón.
 */

/**
 * Un componente de botón de acción personalizado con icono y etiqueta.
 *
 * Renderiza un botón clickeable que muestra un icono a la izquierda y un texto de etiqueta
 * a la derecha. Es útil para acciones secundarias o complementarias en la interfaz.
 *
 * @component
 * @example
 * import EditIcon from '@mui/icons-material/Edit';
 *
 * const MyComponent = () => {
 *   const handleEdit = () => {
 *     console.log('Botón de edición clickeado');
 *   };
 *
 *   return (
 *     <ActionButton
 *       label="Editar"
 *       icon={<EditIcon />}
 *       onClick={handleEdit}
 *     />
 *   );
 * };
 *
 * @param {ActionButtonProps} props - Las props del componente ActionButton.
 */
export const ActionButton = withStyles(actionButtonStyles)(({ classes, label, icon, onClick }) => {
  return (
    <Box onClick={onClick} className={classes.root}>
      <Box>{icon}</Box>
      <Box ml={1}>
        <Typography variant="body2" color="textSecondary">
          {label}
        </Typography>
      </Box>
    </Box>
  )
})
